"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icons = {
    booksofslots: '/img/game-filters/slot.svg',
    instantwin: '/img/game-filters/bonus.svg',
    instant: '/img/game-filters/instant.svg',
    bonus: '/img/game-filters/bonus.svg',
    gambex: '/img/game-filters/gambex.svg',
    jackpots: '/img/game-filters/jackpot.svg',
    tablegames: '/img/game-filters/table.svg',
    blackjack: '/img/game-filters/table.svg',
    live: '/img/game-filters/live.svg',
    lobby: '/img/game-filters/lobby.svg',
    new: '/img/game-filters/new.svg',
    roulette: '/img/game-filters/live.svg',
    top: '/img/game-filters/top.svg',
    all: '/img/game-filters/all.svg',
    topde: '/img/game-filters/top.svg',
    topca: '/img/game-filters/top.svg',
    topfi: '/img/game-filters/top.svg',
    topau: '/img/game-filters/top.svg',
    topno: '/img/game-filters/top.svg',
    topcz: '/img/game-filters/top.svg',
    topbr: '/img/game-filters/top.svg',
    search: '/img/game-filters/search.svg',
    searchByProvider: '/img/game-filters/providers.svg',
    gamesCollections: '/img/game-filters/collections.svg',
    booksofslotsHover: '/img/game-filters/hover/slot.svg',
    instantwinHover: '/img/game-filters/hover/bonus.svg',
    instantHover: '/img/game-filters/hover/instant.svg',
    bonusHover: '/img/game-filters/hover/bonus.svg',
    gambexHover: '/img/game-filters/hover/gambex.svg',
    jackpotsHover: '/img/game-filters/hover/jackpot.svg',
    tablegamesHover: '/img/game-filters/hover/table.svg',
    blackjackHover: '/img/game-filters/hover/table.svg',
    liveHover: '/img/game-filters/hover/live.svg',
    lobbyHover: '/img/game-filters/hover/lobby.svg',
    newHover: '/img/game-filters/hover/new.svg',
    rouletteHover: '/img/game-filters/hover/live.svg',
    topHover: '/img/game-filters/hover/top.svg',
    allHover: '/img/game-filters/hover/all.svg',
    topdeHover: '/img/game-filters/hover/top.svg',
    topcaHover: '/img/game-filters/hover/top.svg',
    topfiHover: '/img/game-filters/hover/top.svg',
    topauHover: '/img/game-filters/hover/top.svg',
    topnoHover: '/img/game-filters/hover/top.svg',
    topczHover: '/img/game-filters/hover/top.svg',
    topbrHover: '/img/game-filters/hover/top.svg',
    searchHover: '/img/game-filters/hover/search.svg',
    searchByProviderHover: '/img/game-filters/hover/providers.svg',
    gamesCollectionsHover: '/img/game-filters/hover/collections.svg',
};
exports.default = Icons;
